import React, { memo } from 'react'

import { P } from '@frame/ui-primitives/p'

type Props = {
  onClick: () => void
}

export const UploadDropzone = memo(function UploadDropzone({ onClick }: Props) {
  return (
    <div
      className="relative mt-4 flex flex-1 cursor-pointer items-center justify-center rounded border border-dashed border-outline bg-background"
      onClick={onClick}
    >
      <P>Drop file(s) here</P>
    </div>
  )
})
